import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useData } from '../../context/DataContext';
import { useAuth } from '../../context/AuthContext';
import TaskList from './TaskList';
import TaskModal from './TaskModal';
import TaskFilters from './TaskFilters';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiPlus } = FiIcons;

const TaskManagement = () => {
  const { tasks } = useData();
  const { hasPermission } = useAuth();

  // Modal States
  const [showModal, setShowModal] = useState(false);
  const [selectedTask, setSelectedTask] = useState(null); // For Editing

  // Filter State
  const [filters, setFilters] = useState({
    status: 'all',
    priority: 'all',
    assignee: 'all'
  });

  // Filter Logic
  const filteredTasks = tasks.filter(task => {
    // Status Filter
    if (filters.status !== 'all' && task.status !== filters.status) return false;
    // Priority Filter
    if (filters.priority !== 'all' && task.priority !== filters.priority) return false;
    // Assignee Filter
    if (filters.assignee !== 'all') {
      const filterId = String(filters.assignee);
      const taskAssignees = Array.isArray(task.assignedTo) ? 
        task.assignedTo.map(String) : 
        [String(task.assignedTo || '')];
      
      if (!taskAssignees.includes(filterId)) return false;
    }
    return true;
  });

  const handleCreateTask = () => {
    setSelectedTask(null);
    setShowModal(true);
  };

  const handleEditTask = (task) => {
    setSelectedTask(task);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedTask(null);
  };

  return (
    <div className="space-y-6">
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4">
        <div>
          <h1 className="text-3xl font-bold text-gray-900">Task Management</h1>
          <p className="text-gray-600 mt-1">Organize and track all your team's tasks</p>
        </div>
        
        {(hasPermission('assign_tasks') || hasPermission('all')) && (
          <motion.button
            whileHover={{ scale: 1.02 }}
            whileTap={{ scale: 0.98 }}
            onClick={handleCreateTask}
            className="flex items-center justify-center space-x-2 bg-blue-600 text-white px-6 py-3 rounded-lg hover:bg-blue-700 transition-colors shadow-sm"
          >
            <SafeIcon icon={FiPlus} className="w-5 h-5" />
            <span>Create Task</span>
          </motion.button>
        )}
      </div>

      <TaskFilters filters={filters} onChange={setFilters} />

      <TaskList 
        tasks={filteredTasks} 
        onEditTask={handleEditTask} 
      />

      <AnimatePresence>
        {showModal && (
          <TaskModal 
            key={selectedTask ? selectedTask.id : 'create-task'}
            task={selectedTask} 
            onClose={handleCloseModal} 
          />
        )}
      </AnimatePresence>
    </div>
  );
};

export default TaskManagement;